<template>
  <div id="app">
    <transition name="fade">
      <router-view/>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex'
/* eslint-disable */
export default {
  name: 'app',
  data () {
    return {
      msg: 'Welcome to BBGame',
      fontBase: 100,
      changeBgTimeout: null,
      ifStopChange: null
    }
  },
  computed: {
    ...mapState([
      'stopBgChangeCountDown'
    ])
  },
  watch: {
    ifStopChange (n, o) {
      if (n === 404) this.clearCounting()
    }
  },
  components: {},
  methods: {
    setFontBase: function () {
      let that = this
      let designWidth = 1920;

      (function (win, doc) {
        if (!win.addEventListener) return
        var html = document.documentElement

        function setFont () {
          //移动pc切换
          let vw = document.documentElement.clientWidth//notice: jumpTo也同样使用了vw判断
          // console.log('设备宽度:',vw);
          if (!that.$lib.IsPC()) {//移动设备显示移动版
            designWidth = 768//设置移动版字体参考值
          } else {
            designWidth = 1920
          }
          // if (vw <= 1024) {//设备宽度达到界定值时显示移动版
          //   designWidth = 768;//设置768px版字体参考值
          // }else {
          //   designWidth = 1920;
          // }

          var cliWidth = html.clientWidth
          html.style.fontSize = that.fontBase * (cliWidth / designWidth) + 'px'
        }

        win.addEventListener('resize', setFont, false)
        setFont()
      })(window, document)
    },
    changeBackground () {
      this.ifStopChange = this.stopBgChangeCountDown
      // console.log('ready to change ___________')
      this.changeBgTimeout = setTimeout(() => {
        if (this.stopBgChangeCountDown !== 404) {
          document.body.style.background = 'url("https://sangokushi.bbgamekr.com/black&white.jpg") center top no-repeat'
          // console.log('change done___________', this.stopBgChangeCountDown)
        }
      }, 5000)
    },
    clearCounting () {
      clearTimeout(this.changeBgTimeout)
      // console.log('clear change done___________')
    }
  },
  created: function () {
    console.log('app created')

    /*
    * 重置轮播init记录
    * */
    localStorage.setItem('initRecordPart7', 'false')
    this.setFontBase();


    //初始化FB SDK
    (function (d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0]
      if (d.getElementById(id)) {
        return
      }
      js = d.createElement(s)
      js.id = id
      js.src = "https://connect.facebook.net/ko_KR/sdk.js"
      fjs.parentNode.insertBefore(js, fjs)
    }(document, 'script', 'facebook-jssdk'))

    window.fbAsyncInit = function () {
      FB.init({
        appId: '148461155872183',
        // appId: '147336525885605',
        // autoLogAppEvents: true,
        // status: true,
        cookie: true,
        // xfbml: true,
        version: 'v2.12'
      })

    }
  },
  mounted: function () {
    let that = this
    this.setFontBase()// 设置font-base
    this.changeBackground()
    window.onload = function () {
      // do sth
    }
  }
}
</script>

<style type="text/scss" lang="scss">
/*!*滚动条样式*!*/
/*!*滚动条整体部分*!*/
/*::-webkit-scrollbar {*/
/*width: .08rem;*/
/*}*/
/*!*滚动条小方块*!*/
/*::-webkit-scrollbar-thumb {*/
/*background-color: rgba(0, 0, 0, 0.6);*/
/*border-radius: .05rem;*/
/*}*/
/*!*滚动轨道两端按钮*!*/
/*::-webkit-scrollbar-button {*/
/*box-shadow: inset 0 0 .06rem rgba(85,85,85,1);*/
/*!*box-shadow: inset 0 0 .06rem rgba(85,85,85,1);*!*/
/*!*border-radius: 10px;*!*/
/*background-color: #555;*/
/*}*/
/*!*滚动轨道 内阴影*!*/
/*::-webkit-scrollbar-track {*/
/*-webkit-box-shadow: inset 0 0 .06rem rgba(255,255,255,1);*/
/*!*border-radius: 10px;*!*/
/*background-color: #F5F5F5;*/
/*}*/
@import "assets/lib/reset.scss";

html,
body {
  width: 100%;
  height: 100%;
  background: #000;
  /*-webkit-overflow-scrolling: touch;*/
  /*transform: translate3d(0,0,0);*/
}

#app {
  font-family: "Microsoft YaHei", Helvetica, Arial, sans-serif;
  width: 100%;
  height: 100%;
  position: relative;
  // overflow-x: hidden;
  .fade-enter-active,
  .fade-leave-active {
    transition: all 0.3s ease;
  }
  .fade-enter,
  .fade-leave-active {
    opacity: 0.6;
  }
}

input:-ms-input-placeholder {
  color: #a9a9a9;
}

/* Internet Explorer 10+ */
input::-webkit-input-placeholder {
  color: #a9a9a9;
}

/* WebKit browsers */
input::-moz-placeholder {
  color: #a9a9a9;
}

/* Mozilla Firefox 4 to 18 */
input:-moz-placeholder {
  color: #a9a9a9;
}

/* Mozilla Firefox 19+ */
.clearfix {
  zoom: 1;
}

.clearfix:after {
  content: "";
  display: block;
  clear: both;
  height: 0;
  visibility: hidden; //sina使用方式
}
</style>



// WEBPACK FOOTER //
// src/App.vue